(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-home"] && !Shopify.designMode) return;
  try {
    
  const initZtartMediaAudio = (control, getActiveVideo, getVideos) => {
    if (!control) return null;

    const toggle = control.querySelector('[data-audio-toggle]');
    const volumeInput = control.querySelector('[data-audio-volume]');
    let muted = true;
    let volume = 0.7;

    const updateControl = () => {
      if (toggle) {
        toggle.classList.toggle('is-muted', muted);
        toggle.setAttribute('aria-pressed', String(!muted));
        toggle.setAttribute('aria-label', muted ? 'Turn sound on' : 'Mute video');
        toggle.setAttribute('title', muted ? 'Turn sound on' : 'Mute video');
      }
      if (volumeInput && document.activeElement !== volumeInput) {
        volumeInput.value = String(Math.round(volume * 100));
      }
    };

    const apply = (playActive = false) => {
      const activeVideo = getActiveVideo();
      const videos = Array.from(getVideos ? getVideos() : []).filter(Boolean);
      control.hidden = !activeVideo;

      videos.forEach((video) => {
        if (video !== activeVideo) {
          video.muted = true;
          video.pause();
          return;
        }

        try {
          video.volume = volume;
        } catch (error) {
          // Some mobile browsers use the device volume instead of the range value.
        }
        video.muted = muted;

        if (playActive && !document.hidden) {
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        }
      });

      updateControl();
    };

    if (toggle) {
      toggle.addEventListener('click', () => {
        muted = !muted;
        if (!muted && volume <= 0) volume = 0.7;
        apply(true);
      });
    }

    if (volumeInput) {
      volumeInput.addEventListener('input', () => {
        const nextVolume = Number(volumeInput.value) / 100;
        volume = Number.isFinite(nextVolume) ? Math.max(0, Math.min(1, nextVolume)) : 0.7;
        muted = volume <= 0;
        apply(true);
      });
    }

    updateControl();
    return {
      refresh: apply,
      isMuted: () => muted,
      getVolume: () => volume
    };
  };

  const initZtartHero = (hero) => {
    if (!hero) return;
    const slides = hero.querySelectorAll('.ztart-home__slide');
    const buttons = hero.querySelectorAll('[data-slide-button]');
    let activeIndex = 0;
    let audioController = null;

    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = index % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === activeIndex));
      buttons.forEach((button, buttonIndex) => button.classList.toggle('is-active', buttonIndex === activeIndex));
      if (audioController) audioController.refresh(true);
    };

    audioController = initZtartMediaAudio(
      hero.querySelector('[data-media-audio]'),
      () => slides[activeIndex] ? slides[activeIndex].querySelector('video') : null,
      () => Array.from(slides).map((slide) => slide.querySelector('video'))
    );

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => showSlide(index));
    });

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const selectedSlide = event.target && event.target.classList && event.target.classList.contains('ztart-home__slide')
          ? event.target
          : null;
        if (!selectedSlide) return;
        const selectedIndex = Array.prototype.indexOf.call(slides, selectedSlide);
        if (selectedIndex >= 0) showSlide(selectedIndex);
      });
    } else if (slides.length > 1) {
      setInterval(() => showSlide(activeIndex + 1), 5200);
    }

    showSlide(0);
  };

  const initZtartStoryFeed = (feed) => {
    if (!feed || feed.dataset.storyFeedReady === 'true') return;

    const track = feed.querySelector('[data-story-track]');
    const nextButton = feed.querySelector('[data-story-next]');
    const currentLabel = feed.querySelector('[data-story-current]');
    const totalLabel = feed.querySelector('[data-story-total]');
    const mobileQuery = window.matchMedia('(max-width: 760px)');
    if (!track) return;

    let items = Array.from(track.querySelectorAll('[data-story-item]'));
    if (!items.length) return;

    const isDesignMode = Boolean(window.Shopify && Shopify.designMode);
    if (!isDesignMode && items.length > 1) {
      for (let index = items.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        const temporaryItem = items[index];
        items[index] = items[randomIndex];
        items[randomIndex] = temporaryItem;
      }
      items.forEach((item) => track.appendChild(item));
    }

    items = Array.from(track.querySelectorAll('[data-story-item]'));
    let activeIndex = 0;
    let scrollFrame = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let storyAudioController = null;

    const setActiveItem = (index) => {
      activeIndex = (index + items.length) % items.length;
      items.forEach((item, itemIndex) => {
        const isActive = itemIndex === activeIndex;
        item.classList.toggle('is-active', isActive);
        const video = item.querySelector('video');
        if (!video) return;
        if (!isActive) {
          video.muted = true;
          video.pause();
        } else if (!storyAudioController && !document.hidden) {
          video.muted = true;
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        }
      });
      if (storyAudioController) storyAudioController.refresh(true);
      if (currentLabel) currentLabel.textContent = String(activeIndex + 1);
    };

    const scrollToItem = (index) => {
      const targetIndex = (index + items.length) % items.length;
      track.scrollTo({top: items[targetIndex].offsetTop, behavior: 'smooth'});
    };

    const updateMobileActiveItem = () => {
      if (!mobileQuery.matches) return;
      const trackCenter = track.scrollTop + track.clientHeight / 2;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      items.forEach((item, itemIndex) => {
        const itemCenter = item.offsetTop + item.offsetHeight / 2;
        const distance = Math.abs(itemCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = itemIndex;
        }
      });

      if (closestIndex !== activeIndex) setActiveItem(closestIndex);
    };

    storyAudioController = initZtartMediaAudio(
      feed.querySelector('[data-media-audio]'),
      () => items[activeIndex] ? items[activeIndex].querySelector('video') : null,
      () => items.map((item) => item.querySelector('video'))
    );

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        if (mobileQuery.matches) {
          scrollToItem(activeIndex + 1);
        } else {
          setActiveItem(activeIndex + 1);
        }
      });
    }

    track.addEventListener('scroll', () => {
      if (!mobileQuery.matches) return;
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(updateMobileActiveItem);
    }, {passive: true});

    track.addEventListener('touchstart', (event) => {
      if (!mobileQuery.matches || event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, {passive: true});

    track.addEventListener('touchend', (event) => {
      if (!mobileQuery.matches || !event.changedTouches.length) return;
      const deltaX = touchStartX - event.changedTouches[0].clientX;
      const deltaY = touchStartY - event.changedTouches[0].clientY;
      if (Math.abs(deltaY) < 52 || Math.abs(deltaY) <= Math.abs(deltaX)) return;
      scrollToItem(activeIndex + (deltaY > 0 ? 1 : -1));
    }, {passive: true});

    items.forEach((item) => {
      const video = item.querySelector('video');
      if (!video) return;
      video.addEventListener('click', () => {
        if (video.paused) {
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        } else {
          video.pause();
        }
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        items.forEach((item) => {
          const video = item.querySelector('video');
          if (video) video.pause();
        });
      } else {
        setActiveItem(activeIndex);
      }
    });

    if (isDesignMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const selectedItem = event.target && event.target.closest
          ? event.target.closest('[data-story-item]')
          : null;
        if (!selectedItem || !feed.contains(selectedItem)) return;
        const selectedIndex = items.indexOf(selectedItem);
        if (selectedIndex < 0) return;
        setActiveItem(selectedIndex);
        if (mobileQuery.matches) scrollToItem(selectedIndex);
      });
    }

    if (totalLabel) totalLabel.textContent = String(items.length);
    if (nextButton) nextButton.hidden = items.length < 2;
    feed.querySelector('.ztart-home__story-count').hidden = items.length < 2;
    feed.dataset.storyFeedReady = 'true';
    setActiveItem(0);
  };

  initZtartHero(document.querySelector('[data-home-hero]'));
  initZtartHero(document.querySelector('[data-mobile-home-hero]'));
  initZtartStoryFeed(document.querySelector('[data-story-feed]'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-conversion"] && !Shopify.designMode) return;
  try {
    
  const conversionDesktopMedia = window.matchMedia('(min-width: 901px)');

  const syncConversionProductVariants = () => {
    document.querySelectorAll('[data-variant-select]').forEach((select) => {
      if (select.dataset.variantBound === 'true') return;
      const section = select.closest('.conversion-product');
      const price = section?.querySelector('[data-variant-price]');
      const button = section?.querySelector('[data-product-form] button[name="add"]');
      const image = section?.querySelector('[data-variant-image]');
      const cards = section?.querySelectorAll('[data-variant-card]') || [];

      const syncVariant = () => {
        const option = select.options[select.selectedIndex];
        const card = section?.querySelector(`[data-variant-card][data-variant-id="${select.value}"]`);
        const available = card?.dataset.available === 'true';
        if (price && card) price.textContent = card.dataset.price;
        if (button) {
          button.disabled = !available;
          button.textContent = available
            ? `${button.dataset.addLabel} - ${card.dataset.buttonPrice}`
            : button.dataset.soldOutLabel;
        }
        if (image && card?.dataset.image) {
          image.src = card.dataset.image;
          image.removeAttribute('srcset');
        }
        cards.forEach((variantCard) => {
          const selected = variantCard.dataset.variantId === select.value;
          variantCard.classList.toggle('is-selected', selected);
          variantCard.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
      };

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          select.value = card.dataset.variantId;
          syncVariant();
        });
      });
      select.dataset.variantBound = 'true';
      syncVariant();
    });
  };

  const syncConversionProductVideos = () => {
    document.querySelectorAll('.conversion-product video:not(.conversion-product__quote-video)').forEach((video) => {
      if (conversionDesktopMedia.matches) {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.preload = 'metadata';
        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => {});
      } else {
        video.pause();
        video.muted = false;
        video.loop = false;
        video.preload = 'none';
      }
    });
  };

  const showSelectedAplusSlide = (target) => {
    const slide = target?.closest?.('[data-aplus-slide]');
    if (!slide) return;
    const carousel = slide.closest('[data-aplus-carousel]');
    const track = carousel?.querySelector('[data-aplus-track]');
    if (!track) return;
    const index = Number(slide.dataset.aplusSlideIndex || 0);
    track.style.transform = `translateX(-${index * 33.3333}%)`;
  };

  const fitAplusMobileCopy = () => {
    document.querySelectorAll('.conversion-product__a-plus-slide--editable').forEach((slide) => {
      const copy = slide.querySelector('.conversion-product__a-plus-slide-copy');
      if (!copy) return;
      copy.style.setProperty('--aplus-auto-scale', '1');
      if (conversionDesktopMedia.matches) return;

      const horizontalInset = 10;
      const verticalInset = 10;
      const anchorX = copy.offsetLeft;
      const anchorY = copy.offsetTop;
      const availableWidth = Math.max(
        1,
        2 * Math.min(anchorX - horizontalInset, slide.clientWidth - anchorX - horizontalInset)
      );
      const availableHeight = Math.max(
        1,
        2 * Math.min(anchorY - verticalInset, slide.clientHeight - anchorY - verticalInset)
      );
      const requiredWidth = Math.max(1, copy.offsetWidth);
      const requiredHeight = Math.max(1, copy.scrollHeight);
      const scale = Math.min(1, availableWidth / requiredWidth, availableHeight / requiredHeight);
      copy.style.setProperty('--aplus-auto-scale', String(Math.max(0.62, scale)));
    });
  };

  let aplusFitFrame;
  const scheduleAplusMobileCopyFit = () => {
    cancelAnimationFrame(aplusFitFrame);
    aplusFitFrame = requestAnimationFrame(() => {
      requestAnimationFrame(fitAplusMobileCopy);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncConversionProductVideos();
      syncConversionProductVariants();
      scheduleAplusMobileCopyFit();
    }, { once: true });
  } else {
    syncConversionProductVideos();
    syncConversionProductVariants();
    scheduleAplusMobileCopyFit();
  }

  conversionDesktopMedia.addEventListener('change', () => {
    syncConversionProductVideos();
    scheduleAplusMobileCopyFit();
  });
  window.addEventListener('resize', scheduleAplusMobileCopyFit, { passive: true });
  if (document.fonts?.ready) {
    document.fonts.ready.then(scheduleAplusMobileCopyFit);
  }
  document.addEventListener('shopify:section:load', () => {
    syncConversionProductVideos();
    syncConversionProductVariants();
    scheduleAplusMobileCopyFit();
  });
  document.addEventListener('shopify:block:select', (event) => {
    showSelectedAplusSlide(event.target);
    scheduleAplusMobileCopyFit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-jd042"] && !Shopify.designMode) return;
  try {
    
  const conversionDesktopMedia = window.matchMedia('(min-width: 901px)');

  const syncConversionProductVariants = () => {
    document.querySelectorAll('[data-variant-select]').forEach((select) => {
      if (select.dataset.variantBound === 'true') return;
      const section = select.closest('.conversion-product');
      const price = section?.querySelector('[data-variant-price]');
      const button = section?.querySelector('[data-product-form] button[name="add"]');
      const image = section?.querySelector('[data-variant-image]');
      const cards = section?.querySelectorAll('[data-variant-card]') || [];

      const syncVariant = () => {
        const option = select.options[select.selectedIndex];
        const card = section?.querySelector(`[data-variant-card][data-variant-id="${select.value}"]`);
        const available = card?.dataset.available === 'true';
        if (price && card) price.textContent = card.dataset.price;
        if (button) {
          button.disabled = !available;
          button.textContent = available
            ? `${button.dataset.addLabel} - ${card.dataset.buttonPrice}`
            : button.dataset.soldOutLabel;
        }
        if (image && card?.dataset.image) {
          image.src = card.dataset.image;
          image.removeAttribute('srcset');
        }
        cards.forEach((variantCard) => {
          const selected = variantCard.dataset.variantId === select.value;
          variantCard.classList.toggle('is-selected', selected);
          variantCard.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
      };

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          select.value = card.dataset.variantId;
          syncVariant();
        });
      });
      select.dataset.variantBound = 'true';
      syncVariant();
    });
  };

  const syncConversionProductVideos = () => {
    document.querySelectorAll('.conversion-product video:not(.conversion-product__quote-video)').forEach((video) => {
      if (conversionDesktopMedia.matches) {
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.preload = 'metadata';
        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => {});
      } else {
        video.pause();
        video.muted = false;
        video.loop = false;
        video.preload = 'none';
      }
    });
  };

  const showSelectedAplusSlide = (target) => {
    const slide = target?.closest?.('[data-aplus-slide]');
    if (!slide) return;
    const carousel = slide.closest('[data-aplus-carousel]');
    const track = carousel?.querySelector('[data-aplus-track]');
    if (!track) return;
    const index = Number(slide.dataset.aplusSlideIndex || 0);
    track.style.transform = `translateX(-${index * 33.3333}%)`;
  };

  const fitAplusMobileCopy = () => {
    document.querySelectorAll('.conversion-product__a-plus-slide--editable').forEach((slide) => {
      const copy = slide.querySelector('.conversion-product__a-plus-slide-copy');
      if (!copy) return;
      copy.style.setProperty('--aplus-auto-scale', '1');
      if (conversionDesktopMedia.matches) return;

      const horizontalInset = 10;
      const verticalInset = 10;
      const anchorX = copy.offsetLeft;
      const anchorY = copy.offsetTop;
      const availableWidth = Math.max(
        1,
        2 * Math.min(anchorX - horizontalInset, slide.clientWidth - anchorX - horizontalInset)
      );
      const availableHeight = Math.max(
        1,
        2 * Math.min(anchorY - verticalInset, slide.clientHeight - anchorY - verticalInset)
      );
      const requiredWidth = Math.max(1, copy.offsetWidth);
      const requiredHeight = Math.max(1, copy.scrollHeight);
      const scale = Math.min(1, availableWidth / requiredWidth, availableHeight / requiredHeight);
      copy.style.setProperty('--aplus-auto-scale', String(Math.max(0.62, scale)));
    });
  };

  let aplusFitFrame;
  const scheduleAplusMobileCopyFit = () => {
    cancelAnimationFrame(aplusFitFrame);
    aplusFitFrame = requestAnimationFrame(() => {
      requestAnimationFrame(fitAplusMobileCopy);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncConversionProductVideos();
      syncConversionProductVariants();
      scheduleAplusMobileCopyFit();
    }, { once: true });
  } else {
    syncConversionProductVideos();
    syncConversionProductVariants();
    scheduleAplusMobileCopyFit();
  }

  conversionDesktopMedia.addEventListener('change', () => {
    syncConversionProductVideos();
    scheduleAplusMobileCopyFit();
  });
  window.addEventListener('resize', scheduleAplusMobileCopyFit, { passive: true });
  if (document.fonts?.ready) {
    document.fonts.ready.then(scheduleAplusMobileCopyFit);
  }
  document.addEventListener('shopify:section:load', () => {
    syncConversionProductVideos();
    syncConversionProductVariants();
    scheduleAplusMobileCopyFit();
  });
  document.addEventListener('shopify:block:select', (event) => {
    showSelectedAplusSlide(event.target);
    scheduleAplusMobileCopyFit();
  });

  } catch(e) { console.error(e); }
})();
})();
